<div class="modal-header">
  <h4 class="modal-title">Request an Appointment</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
  <div class="modal-body">
    <div class="form-group">
      <label for="appointmentTime">For</label>
      <div class="form-row align-items-center">
        <div class="col-auto my-1">
          <select class="custom-select" [(ngModel)]="appointmentRequest.appointmentTime" name="appointmentTime"
                  id="appointmentTime">
              <option value="anytime" selected="selected">Anytime</option>
              <option value="morning">Morning</option>
              <option value="afternoon">Afternoon</option>
              <option value="evening">Evening</option>
          </select>
        </div>
        <div class="col-auto my-1">
          <label class="my-1">on</label>
        </div>
        <div class="col-auto my-1">
          <div class="input-group">
            <div class="input-group-prepend">
              <button type="button" class="input-group-text" (click)="picker.toggle()">
                <fa-icon [icon]="faCalendarAlt"></fa-icon>
              </button>
            </div>
            <label class="sr-only" for="appointmentDate">Date</label>
            <input class="form-control" type="text" ngbDatepicker #picker="ngbDatepicker" [minDate]="minDate"
                   [(ngModel)]="dateModel" name="appointmentDate"
                   id="appointmentDate" [ngClass]="{'is-invalid': !!dateErrorMessage}"
                    required style="width: 150px"/>
          </div>
          <div *ngIf="!!dateErrorMessage" class="invalid-feedback d-block">
            {{dateErrorMessage}}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="staffMember">Staff Member (optional)</label>
      <input class="form-control" type="text" name="staffMember" [(ngModel)]="appointmentRequest.staffMember"
             id="staffMember"/>
    </div>
    <div class="form-group">
      <label for="location">Location (optional)</label>
      <input class="form-control" type="email" name="location" [(ngModel)]="appointmentRequest.location"
             id="location">
    </div>
    <div class="form-group">
      <label for="message">Message (optional)</label>
      <textarea class="form-control" name="message" rows="5" [(ngModel)]="appointmentRequest.message"
                id="message"></textarea>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('cancel')">
      Discard Request
    </button>
    <button type="button" class="btn btn-primary" (click)="submit()">
      Submit Request
    </button>
  </div>

